const BASE_URL = import.meta.env.BASE_URL
const DATA_VERSION = import.meta.env.VITE_ARMORY_DATA_VERSION ?? ''

function appendVersion(url: string) {
  if (!DATA_VERSION) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}v=${encodeURIComponent(DATA_VERSION)}`
}

export function resolvePublicPath(path?: string) {
  const cleanPath = (path ?? '').replace(/^\/+/, '')
  if (!cleanPath) {
    return appendVersion(`${BASE_URL}icons/placeholder.svg`)
  }
  return appendVersion(`${BASE_URL}${cleanPath}`)
}
